import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const tableColumns = (handleAction) => [
    { dataField: "id", text: "ID", sort: true, headerStyle: { width: '80px' } },
    { dataField: "title", text: "Notification Title", sort: true },
    { dataField: "message", text: "Message", sort: true },
    { dataField: "type", text: "Notification Type", sort: true },
    { dataField: "target_audience", text: "Audience", sort: true },
    { dataField: "channel", text: "Channel", sort: true },
    { dataField: "scheduled_at", text: "Scheduled At", sort: true },
    { dataField: "sent_at", text: "Sent At", sort: true },
    {
        dataField: "status",
        text: "Status",
        formatter: (cell) => {
            const statusMap = { "Sent": "bg-success-subtle text-success", "Pending": "bg-success-subtle text-info", "Failed": "bg-danger-subtle text-danger" };
            const badgeClass = statusMap[cell] || "bg-secondary-subtle text-secondary";
            return (
                <span className={`badge rounded-pill ${badgeClass}`} style={{ fontSize: '11px', padding: '5px 10px' }}>
                    {cell}
                </span>
            );
        }
    },
    {
        dataField: "actions", text: "Action", headerClasses: "text-end px-4", classes: "text-end px-4", isDummyField: true,
        formatter: (_, row) => (
            <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm border">
                    <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => handleAction("View", row)}>
                        <i className="bx bx-show-alt me-2 text-primary"></i> View
                    </DropdownItem>
                    <DropdownItem onClick={() => handleAction("Edit", row)}>
                        <i className="bx bx-pencil me-2 text-success"></i> Edit
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger">
                        <i className="bx bx-trash me-2"></i> Delete
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        ),
    },
];